import connectAsync from '../../../utils/connectAsync';
import { fetchMe } from '../../../actions/me';
import fetchProducts from '../../../utils/connectors/fetchProducts';
import fetchPartner from '../../../utils/connectors/fetchPartner';
import isSubscriptionRenewable from '../../../utils/subscription/isSubscriptionRenewable';
import OauthAuthConfirmationRoute from './OauthConfirmationRoute';

// exported for testing
export function fetchMeAndProducts({ location }) {
  return async (dispatch, getState) => {
    await dispatch(fetchMe());

    const isRenew = isSubscriptionRenewable(getState());

    return dispatch(fetchProducts(location, isRenew));
  };
}

export default connectAsync([fetchMeAndProducts, fetchPartner])(
  OauthAuthConfirmationRoute,
);
